import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-page-footer',
  standalone: true,
  templateUrl: './page-footer.component.html',
  styleUrl: './page-footer.component.scss'
})
export class PageFooterComponent {
  showCloseButton = input<boolean>(true);
  closeClick = output<void>();

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  onCloseClick(): void {
    this.closeClick.emit();
  }
}
